import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DatosComercio, LlamarCliente } from 'src/app/global/interfaces/datos-comercio';
import { ActEconomicasRubrosService } from 'src/app/global/services/act-economicas-rubros.service';
import { DatosComercioService } from 'src/app/global/services/datos-comercio.service';
import { DatosComercioServiceVM } from '../../../services/datos-comercio.service';

import { IdentificacionComercioResponse } from 'src/app/global/interfaces/identificacion-comercio-response';
import restriccionProdRubros from 'src/assets/restricciones_productos_rubros.json';

@Injectable()
export class DatosComercioProviderVM extends DatosComercioServiceVM {
 
  RestriccionProdRubros: any = restriccionProdRubros;

  Productos: Array<string> = ['SMARTPOS', 'COBRO_QR', 'CREACION_SITIO_PST', 'CREACION_SITIO_ALIANZA_WIX', 'INTEGRADOR_TRANSBANK', 'INTEGRADOR_CLIENTE'];

  constructor(private datosComercioServ: DatosComercioService, private actRubroService: ActEconomicasRubrosService) {
    super();
  }

  obtieneIdentificacionComercio(correo?: string): Observable<IdentificacionComercioResponse> {
    return this.datosComercioServ.obtieneIdentificacionComercio(correo)
      .pipe(map(this.obtieneIdentComercioOK), catchError(this.cbError));
  }

  private obtieneIdentComercioOK(resp) {
    return resp;
  }

  registraDatosComercio(datosComercio: DatosComercio): Observable<any> {
    return this.datosComercioServ.registraDatosComercio(datosComercio)
      .pipe(map(this.registraDatosOK), catchError(this.cbError));
  }

  private registraDatosOK(resp) {
    return resp;
  }

  obtieneLocalizaciones(): Observable<any> {
    return this.datosComercioServ.obtieneLocalizaciones()
      .pipe(map(this.obtieneLocalizacionesOK), catchError(this.cbError));
  }

  private obtieneLocalizacionesOK(resp) {
    return resp;
  }

  private cbError(error) {
    return throwError(error);
  }

  autenticacaComercio(run: number, tokenExterno: String): Observable<any> {
    return this.datosComercioServ.autenticaComercio(run, tokenExterno)
      .pipe(map(this.obtenerAutenticacaComercio), catchError(this.cbError));
  }

  private obtenerAutenticacaComercio = (response) => response;

  obtenerCartaPoder(): Observable<any> {
    return this.datosComercioServ.obtenerCartaPoder().pipe(map(this.obtenerCartaPoderResponse), catchError(this.cbError));
  }

  private obtenerCartaPoderResponse = response => response;

  llamarCliente(llamarCliente: LlamarCliente): Observable<any> {
    return this.datosComercioServ.llamarCliente(llamarCliente).pipe(map(response => response), catchError(this.cbError));

  }


}
